import { GetListParams, GetOneParams } from 'react-admin';
import { registerModuleDataProvider, CustomDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';
import { Resources } from '../resource';

export class DataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (!resource?.startsWith(Resources.redpacket)) return Promise.reject(new Error('Unsupported getList resource'));
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    if (!resource?.startsWith(Resources.redpacket)) return Promise.reject(new Error('Unsupported create resource'));
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (!resource?.startsWith(Resources.redpacket)) return Promise.reject(new Error('Unsupported update resource'));
  }
  // eslint-disable-next-line class-methods-use-this
  async getOne(resource: string, params: GetOneParams): Promise<any> {
    if (!resource?.startsWith('redpacket'))  return Promise.reject(new Error('Unsupported getOne resource'));
    return { data: { resource: resource, ...params } };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (!resource?.startsWith(Resources.redpacket)) return Promise.reject(new Error('Unsupported delete resource'));
    return { data: { ...params } };
  }
}

// 创建实例并导出
export const dataProvider = new DataProvider();

// 注册 activity/tasks 模块的数据提供者
export function initActivityTasksDataProvider() {
  registerModuleDataProvider(Resources.redpacket, dataProvider);
  registerModuleDataProvider(Resources.redpacketTypeConfig, dataProvider);
  registerModuleDataProvider(Resources.redpacketTypeConfig, dataProvider);
  registerModuleDataProvider(Resources.redpacketOverview, dataProvider);
  registerModuleDataProvider(Resources.redpacketIntervention, dataProvider);
  registerModuleDataProvider(Resources.redpacketredPacketConfig, dataProvider);
  registerModuleDataProvider(Resources.redpacketRecords, dataProvider);
  registerModuleDataProvider(Resources.redpacketLottoDrawConfigs, dataProvider);
  registerModuleDataProvider(Resources.redpacketDesignatedRedPackets, dataProvider);
  registerModuleDataProvider(Resources.redpacketLeaderboardCycles, dataProvider);
  registerModuleDataProvider(Resources.redpacketDailyPrizePool, dataProvider);
  registerModuleDataProvider(Resources.redpacketDailyPrizePoolStatus, dataProvider);
  registerModuleDataProvider(Resources.redpacketDailyPrizePoolConfigAudit, dataProvider);
  registerModuleDataProvider(Resources.redpacketFeatureFlags, dataProvider);
  registerModuleDataProvider(Resources.redpacketCampaignDates, dataProvider);
  registerModuleDataProvider(Resources.redpacketRewardPoolBalances, dataProvider);
  registerModuleDataProvider(Resources.redpacketOverlay, dataProvider);
  registerModuleDataProvider(Resources.redpacketLuckyLottoHistory, dataProvider);
}

// 自动初始化
initActivityTasksDataProvider();
